import { Type } from 'class-transformer';

// Model imports
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { CBVendorSelectorResultDto } from '../../common/cb-vendor-selector-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';
import { GLAccountLabelSelectorResultDto } from '../../common/gl-account/gl-account-label-selector-result-dto';
import { GLAccountSelectorResultDto } from '../../common/gl-account/glaccount-selector-result-dto';
import { APAdjustmentRawDto } from './ap-adjustment-raw-dto';

export class APAdjustmentEditorResultDto {
    @Type(() => APAdjustmentRawDto)
    adjustment: APAdjustmentRawDto;

    @Type(() => Date)
    closedBookPeriodDate: Date;

    @Type(() => KeyValueResultDto)
    adjustmentTypes: KeyValueResultDto[];

    @Type(() => CBVendorSelectorResultDto)
    vendorList: CBVendorSelectorResultDto[];

    @Type(() => GLAccountSelectorResultDto)
    glAccounts: GLAccountSelectorResultDto[];

    @Type(() => GLAccountLabelSelectorResultDto)
    glAccountsLabels: GLAccountLabelSelectorResultDto[];

    @Type(() => DimensionSelectorResultDto)
    glDimensions: DimensionSelectorResultDto[];

    defaultOffsetGLAccountNumber: string;
    entityUsesSubCategory: boolean;

    /*
        If AllowLimitedEdit and AllowEdit both are true then user can modify any property at Header and line level.
        If only AllowLimitedEdit is true then user can modify Document date, description at header level and Line item description
    */
    allowEdit: boolean;
    allowLimitedEdit: boolean;

    allowDelete: boolean;
    allowReverse: boolean;
    allowApplyDebit: boolean;
    allowReclassify: boolean;
}
